import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Row, Col } from 'antd';
import Header from '@components/shared/Header';
import { ListingAmenities } from '@root/types';
import Amenity from '@components/shared/Amenity';
import { filterAndOrderAmenities } from '@shared/amenitiesOrdering';
import { filterAndOrderAmenities as filterAndOrderAmenitiesDeprecated } from '@shared/amenitiesOrderingDeprecated';
import s from './Amenities.module.less';

type Props = {
  amenities: ListingAmenities;
};

const Amenities = ({ amenities: a }: Props) => {
  const flags = useFlags();
  const { t } = useTranslation('listing');

  let amenities;
  if (flags['sort-amenities-by-translation-order']) {
    amenities = filterAndOrderAmenities(a, t);
  } else {
    amenities = filterAndOrderAmenitiesDeprecated(a);
  }

  return amenities.length > 0 ? (
    <section className={s.container}>
      <Header>{t('common:amenities.title')}</Header>
      <Row>
        <Col sm={24} lg={24} md={19}>
          <Row>
            {amenities.map(amenity => (
              <Col className={s['amenity-row']} key={amenity.name} sm={12} md={12} lg={8}>
                <Amenity {...amenity} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </section>
  ) : null;
};

export default Amenities;
